<template lang="html">
<!--v-show="el.newFile"-->
  <div  id="boxa" class="main" :class="el.maxFile">
    <div class="name" id="barb" :class="{hidden:hidden}">
      {{message.Al118}}
    </div>
    <div class="box"
      v-loading="boxLoading"
      :element-loading-text="boxLoadingText">
      <div class="cell">
        <span class="cell-name upload-cell-title">
          {{message.Fl114}}:&nbsp;&nbsp;{{ user_name }}
        </span>
      </div>
      <div class="cell" :class="{titleBtoLine:titleBtoLine}">
        <span class="cell-name upload-cell-title">
          {{message.Al121}}:&nbsp;&nbsp;&nbsp;&nbsp;
          <span :class="{hidden:!hidden}">{{ title }}</span>
          <input :class="{hidden:hidden}" type="text" name="text" v-model="title" class="bottom_line" style="height:30px;"/>
        </span>
      </div>
      <div class="cell file" :class="{hidden:hidden}">
        <span class="cell-name">
          {{message.Al118}}
        </span>
        <span class="upload-choose">
          {{message.Al137}}
          <div class="upload-body">
            <span class="upload-cell" @click="addFiles">{{message.Al157}}</span>
            <span class="upload-cell" @click="addFolder">{{message.Al158}}</span>
          </div>
        </span>
        <div id="dodrop"
          class="upload"
          @drop="dodrop($event)"
          @ondragenter="over($event)"
          v-loading="loading"
          :element-loading-text="message.Al122">
          <i class="el-icon-upload"
            v-show="uploadIcon"
            style="font-size:120px;color:#ccc;margin-top:10px"
          ></i>
          <div style="color:#ccc" v-show="uploadIcon" class="el-upload__text">{{message.Al123}}</div>
          <div class="fileList">
            <ul class="el-upload-list el-upload-list--text">
              <li class="el-upload-list__item is-success" v-for="(file, index) in files" :key="file.id">
                <a class="el-upload-list__item-name">
                  <i class="el-icon-document" v-show="file.file"></i>
                  <i class="material-icons icon-folder" v-show="!file.file">folder_open</i>
                  {{ file.name }}
                </a>
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-circle-check"></i>
                </label>
                <i class="el-icon-close" @click="clearFile(index)"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="fileListTitle" :class="{hidden:!hidden}">
        <div class="name">{{ message.Al214 }}</div>
        <div class="refesh">
          <i class="material-icons" :class="{refresh_animation:flagAnimation}" @click="refesh">autorenew</i>
        </div>
      </div>
      <div class="file-wrap" :class="{noHeight:!noHeight}">
        <div class="fileList" :class="{hidden:!hidden}">
          <!-- <comp-files
            v-for = "file in uploadFiles"
            :key = "file.id"
            :id="file.id"
            :name="file.name"
            :size="file.size"
            :percent="file.persent"
            :fileState="file.state"
            @cellChecked="checkedFiles">
          </comp-files> -->
          <comp-files
            v-for = "file in uploadFiles"
            :key = "file.id"
            :id="file.id"
            :name="file.name"
            :size="file.size"
            :percent="file.persent"
            :fileState="file.state"
            :checkedList="checkedList"
            @cellChecked="checkedFiles">
          </comp-files>
        </div>

        <div class="cell" style="border-bottm:1px solid #ccc" :class="{hidden:hidden}">
          <span class="cell-name" style="display:inline-block;padding-left:30px;width:115px;">
            {{message.Al125}}:
          </span>
          <input type="text" name="text" v-model="notes" class="bottom_line" />
          <!-- <el-input
          type="textarea"
          v-model="notes"
          :placeholder="message.Al125"
          :autosize="{ minRows: 4, maxRows: 4}"
          style="width:360px;margin: 0 auto;"
          >
          </el-input> -->
        </div>
      </div>
      <div style="text-align:center;" v-if="hidden && total > 8">
        <el-pagination
          small
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
          :current-page.sync="num"
          @current-change="pageList">
        </el-pagination>
      </div>
      <div class="download-bottom" :class="{hidden:!hidden}">
        <div class="persent-bottom">
          <label class="title">{{ message.Al217 }}:</label>
          <span>{{ uploadPensent }}%</span>
        </div>
        <div class="bottom-progress">
          <el-progress :show-text="false" :stroke-width="8" :percentage="uploadPensent"></el-progress>
        </div>
        <span v-if="taskState !== 2" class="transfer-style">
          <span v-if="taskState === 0">
            {{message.Al100}}
          </span>
          <span v-else-if="taskState === 1">
            {{message.Al101}}
          </span>
          <span  v-else-if="taskState === 3">
            {{message.Al102}}
          </span>
          <span v-else-if="taskState === 4">
            <i class="el-icon-loading"></i> {{message.Al103}}
          </span>
          <span v-else-if="taskState === 5">
            <i class="el-icon-loading"></i> {{message.Al104}}
          </span>
          <span v-else-if="taskState === 6">
            {{message.Al105}}
          </span>
          <span v-else-if="taskState === 7">
            {{message.Al150}}
          </span>
          <span class="show-error" v-else :title="message.Al151">
            {{message.Al151}}
          </span>
        </span>
        <span class="status transfer-style" v-if="taskState === 2">
          <span>
            {{ message.Sl108 }}
          </span>
        </span>
      </div>
      <div class="rp_bottom">
        <router-link class="more-opt" :to="{path: '/inbox'}">{{ message.Al213 }}</router-link>
        <el-button type="primary" :disabled="sendDisabled" @click="sentFiles()" class="submit" size="small" :class="{hidden:hidden}">{{message.Al126}}</el-button>
        <!-- <el-button type="primary"  @click="toggle" size="small">{{message.Al126}}</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import startDrag from '@/global/drag.js'
import CompFiles from '@/components/other/workspace/components/files.vue'
export default {
  components: {
    CompFiles
  },
  computed: {
    ...mapGetters({
      el: 'el',
      size: 'size',
      account: 'account',
      app: 'app',
      transfer: 'transfer'
    }),
    sendDisabled: function () {
      if (
        this.files.length === 0 ||
        this.title === ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'transfer.aliveList' () {
      if (this.transfer.aliveList.error !== 0) {
        return
      }
      if (this.taskId !== '') {
        this.$app.taskMore('upload', this.taskId, res => {
          this.taskState = res.taskState
          if (res.taskState === 2) {
            this.taskEventFlag = false
            this.uploadPensent = 100
            this.taskId = ''
            this.fileList(this.pageSize, this.num, this.packageid)
          } else {
            this.uploadPensent = parseInt(res.transfer.percent)
          }
        })
      }
    },
    'el.newFile': function (val) {
      if (val) {
        this.resizeWinMax()
      }
    },
    files: function (val) {
      if (val.length !== 0) {
        this.uploadIcon = false
        if (this.title === '') {
          this.title = val[0].name
        }
      } else {
        this.uploadIcon = true
      }
    },
    size: function (val) {
      if (this.el.maxFile === '') {
        this.resizeWinMax()
      }
    }
  },
  data () {
    return {
      message: {
        Al100: this.$lang.ui.app.l100,
        Al101: this.$lang.ui.app.l101,
        Al102: this.$lang.ui.app.l102,
        Al103: this.$lang.ui.app.l103,
        Al104: this.$lang.ui.app.l104,
        Al105: this.$lang.ui.app.l105,
        Fl114: this.$lang.ui.form.l114,
        Al118: this.$lang.ui.app.l118,
        Al120: this.$lang.ui.app.l120,
        Al121: this.$lang.ui.app.l121,
        Al122: this.$lang.ui.app.l122,
        Al123: this.$lang.ui.app.l123,
        Al125: this.$lang.ui.app.l125,
        Al126: this.$lang.ui.app.l126,
        Al132: this.$lang.ui.app.l132,
        Al137: this.$lang.ui.app.l137,
        Al150: this.$lang.ui.app.l150,
        Al151: this.$lang.ui.app.l151,
        Al157: this.$lang.ui.app.l157,
        Al158: this.$lang.ui.app.l158,
        Al159: this.$lang.ui.app.l159,
        Al213: this.$lang.ui.app.l213,
        Al214: this.$lang.ui.app.l214,
        Al217: this.$lang.ui.app.l217,
        Sl108: this.$lang.ui.notice.l108
      },
      browser: this._global.config.browser,
      showChoose: false,
      showChooseCell: false,
      boxPosition: {
        left: 0,
        top: 0
      },
      boxLoading: false,
      boxLoadingText: this.$lang.ui.app.l127,
      uploadIcon: true,
      loading: false,
      users: [],
      email: '',
      files: [],
      notes: '',
      hidden: false,
      flagAnimation: false,
      uploadFiles: [],
      total: 0,
      uploadPensent: 0,
      num: 1,
      pageSize: 8,
      checkedList: [],
      noHeight: false,
      titleBtoLine: false,
      title: '',
      packageid: '',
      taskEventFlag: false,
      taskState: 0,
      user_name: '',
      receiverIds: [],
      project_id: '',
      taskId: ''
    }
  },
  mounted () {
    this._global.windowSize()
    window.removeEventListener('resize', this._global.windowSize, false)
    window.addEventListener('resize', this._global.windowSize, false)
    window.CydexDrage = (type, path) => {
      if (this.el.newFile) {
        if (type === 'file') {
          const fileNameList = path.split('/')
          const fileName = fileNameList[fileNameList.length - 1]
          this.files.push({
            name: fileName,
            path: path,
            file: true
          })
        }
        if (type === 'folder') {
          const folderNameList = path.split('/')
          const folderName = folderNameList[folderNameList.length - 1]
          this.files.push({
            name: folderName,
            path: path,
            file: false
          })
        }
      }
    }
  },
  created () {
    this.getTokenInfo()
  },
  methods: {
    getTokenInfo () {
      let pathname = window.location.pathname
      let index = pathname.lastIndexOf('/')
      let token = pathname.substring(index + 1, pathname.length)
      this.$api.getRequestToSendInfo(token, res => {
        if (res.err === 1) {
          this.$router.push({
            path: '/app/workspace'
          })
        } else {
          this.user_name = res.data.receive_user_info.user_name
          this.receiverIds.push(res.data.receive_user_info.user_id)
          this.project_id = res.data.project_id
        }
      })
    },
    fileList (pageSize, pageNum, packageid) {
      let paramsData = {
        'op': 'upload',
        'with_state': 1,
        'page_num': pageNum,
        'page_size': pageSize
      }
      this.$http.get('/cydex/api/v1/packages/' + packageid + '/files', { params: paramsData })
        .then(res => {
          this.uploadFiles = []
          this.total = res.data.total_num
          res.data.files.forEach(item => {
            this.uploadFiles.push({
              id: item.id,
              name: item.name,
              size: this._global.trafficSwitch(item.size),
              state: 'download',
              persent: parseInt(item.state.finished_size / item.size * 100)
            })
          })
        })
    },
    checkedFiles (msg) {
      if (msg.checked) {
        this.checkedList.push({
          id: msg.id
        })
      } else {
        for (var i = 0; i < this.checkedList.length; i++) {
          if (this.checkedList[i].id === msg.id) {
            this.checkedList.splice(i, 1)
          }
        }
      }
    },
    resizeWinMax () {
      this.onMax()
      this.boxPosition.left = this.size.width * 0.5 - 230 + 'px'
      this.boxPosition.top = this.size.height * 0.15 + 'px'
    },
    onMin () {
      this.boxPosition.left = this.size.width - 380 + 'px'
      this.boxPosition.top = this.size.height - 85 + 'px'
      this.controlShow = false
      var oBox = document.getElementById('box')
      var oBar = document.getElementById('bar')
      startDrag(this.boxPosition, oBar, oBox)
      this.$store.dispatch('maxFile', 'min')
    },
    onMax () {
      this.boxPosition.left = this.size.width * 0.5 - 230 + 'px'
      this.boxPosition.top = this.size.height * 0.15 + 'px'
      this.controlShow = true
      this.el.maxFile = ''
    },
    dodrop (e) {
      if (this._global.config.browser === 'qt') {
        return
      }
      this._global.fileFalse(e.dataTransfer.files, nameList => {
        if (nameList.length === 0) {
          return
        }
        this.loading = true
        var value = nameList
        this.$app.drag(value, response => {
          this.loading = false
          if (response.draggedFiles) {
            for (var i = 0; i < response.draggedFiles.length; i++) {
              var fileNameList = response.draggedFiles[i].split('/')
              var fileName = fileNameList[fileNameList.length - 1]
              this.files.push({
                name: fileName,
                path: response.draggedFiles[i],
                file: true
              })
            }
            for (var a = 0; a < response.draggedFolders.length; a++) {
              var folderNameList = response.draggedFolders[a].split('/')
              var folderName = folderNameList[folderNameList.length - 1]
              this.files.push({
                name: folderName,
                path: response.draggedFolders[a],
                file: false
              })
            }
          }
        })
      })
    },
    addFiles () {
      this.$app.appFiles(response => {
        this.loading = false
        if (response.selectedFiles) {
          for (var i = 0; i < response.selectedFiles.length; i++) {
            var fileNameList = response.selectedFiles[i].split('/')
            var fileName = fileNameList[fileNameList.length - 1]
            this.files.push({
              name: fileName,
              path: response.selectedFiles[i],
              file: true
            })
          }
        }
      })
    },
    addFolder () {
      this.$app.appFolder(response => {
        this.loading = false
        if (response.selectedFolder) {
          var folderNameList = response.selectedFolder.split('/')
          var folderName = folderNameList[folderNameList.length - 1]
          this.files.push({
            name: folderName,
            path: response.selectedFolder,
            file: false
          })
        }
      })
    },
    clearFile (index) {
      this.files.splice(index, 1)
    },
    sentFiles () {
      if (
        this.files.length === 0
      ) {
        return
      }
      this.boxLoadingText = this.$lang.ui.app.l127
      this.boxLoading = true
      setTimeout(() => {
        if (this.boxLoading) {
          var ae = []
          for (var b = 0; b < this.files.length; b++) {
            if (!this.files[b].file) {
              ae.push(this.files[b].path)
            }
          }
          this.$app.getFilesNum(ae, response => {
            if (response.number > 2000) {
              this.boxLoadingText = this.$lang.ui.app.l128
            }
          })
        }
      }, 15000)
      var emailList = []

      var filesList = []
      var foldersList = []
      for (var a = 0; a < this.files.length; a++) {
        if (this.files[a].file) {
          filesList.push(this.files[a].path)
        } else {
          foldersList.push(this.files[a].path)
        }
      }
      var all = {
        'title': this.title,
        'projectId': this.project_id,
        'notes': this.notes,
        'receiverIds': this.receiverIds,
        'fileNames': filesList,
        'folderNames': foldersList,
        'new-task': 2
      }
      if (emailList.length !== 0) {
        var e = {
          email_list: emailList,
          project_id: this.project_id
        }
        this.$api.getEmailUid(e, response => {
          if (response !== 1) {
            this.sentFilesFuc(all)
          } else {
            this.boxLoading = false
            this.$message({
              message: this.$lang.ui.prompt.l135,
              type: 'warning',
              duration: 1200
            })
          }
        })
      } else {
        this.sentFilesFuc(all)
      }
    },
    sentFilesFuc (all) {
      this.$app.newPackage(all, response => {
        this.boxLoading = false
        if (response === 1) {
          this.$message.error(this.$lang.ui.app.l129 + ' (error: ' + response.error + ')')
          return
        }
        if (response.error === 11 || response.error === 111) {
          this.$message.error(this.$lang.ui.app.l130)
          return
        }
        var id = response.pkgId
        if (id === '') {
          this.$message.error(this.$lang.ui.app.l129 + ' (error: ' + response.error + ')')
          return
        }
        this.$store.dispatch('sentFile', true)
        if (response.error === 0 || response.error === 100) {
          this.hidden = true
          this.noHeight = true
          this.titleBtoLine = true
          this.$message({
            message: this.$lang.ui.app.l131,
            type: 'success',
            duration: 4000
          })
          this.packageid = response.packageId
          this.taskId = response.taskId
          this.fileList(this.pageSize, this.num, response.packageId)
        } else {
          this.$message.error(this.$lang.ui.app.l129)
        }
      })
    },
    refesh () {
      this.flagAnimation = true
      this.fileList(this.pageSize, this.num, this.packageid)
      setTimeout(() => {
        this.flagAnimation = false
      }, 3000)
    },
    pageList (index) {
      this.fileList(this.pageSize, index, this.packageid)
    },
    toggle () {
      this.hidden = !this.hidden
      this.noHeight = !this.noHeight
      this.titleBtoLine = !this.titleBtoLine
    }
  }
}
</script>

<style lang="css" scoped>
.hidden {
  display: none !important;
  transition: all 3s;
}
.titleBtoLine {
  border-bottom: 1px solid #f2f2f2;
}
.main {
  z-index: 10000;
  position: fixed;
  width: 650px;
  min-width: 650px;
  height: 560px;
  background-color: #fff;
  overflow: hidden;
  height: auto;
  left: 50%;
  margin-left: -325px;
  border-radius: 4px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.main .name {
  font-size: 14px;
  padding: 0 45px;
  text-align: left;
  color: #333;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #f2f2f2;
}
.noHeight {
  height: unset !important;
}
.upload-body {
  display: none;
  position: absolute;
  border: 1px solid #d8dce5;
  left: -2px;
  top: 16px;
  background-color: #fff;
  border-radius: 4px;
  width: 115px;
}
.upload-cell {
  display: inline-block;
  color: #5a5e66;
  padding: 4px 8px;
  width: 100%;
}
.upload-cell:hover {
  color: #212121;
}
.upload-choose:hover .upload-body {
  display: block;
}
.upload-choose {
  position: absolute;
  display: block;
  cursor: pointer;
  top: 8px;
  color: #007bc5;
  z-index: 3;
  left: 50px;
}
.cntrol i {
  float: right !important;
  cursor: pointer;
  text-align: center;
}
.main.min {
  left: auto;
  top: auto;
  right: 10px;
  width: 285px;
  bottom: 30px;
  height: 35px;
}
.main.min .box {
  display: none;
}
.name i {
  margin-top: 5px;
  float: left;
}
.box {
  overflow: hidden;
  width: 100%;
  padding: 15px;
}
.box .upload-cell-title {
  display:inline-block;
  padding-left: 30px;
  width: 100%;
}
.user-name {
  float: left;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-email {
  float: right;
  color: #8492a6;
  width: 140px;
  text-align: right;
  font-size: 12px;
  padding-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell {
  display: flex;
  width: 100%;
  padding: 4px 1px;
  /*border-bottom: 1px solid #ccc;*/
}
.cell.file {
  position: relative;
}
.cell-name {
  display: none;
  float: left;
  font-size: 14px;
  width: 60px;
  font-weight: 600;
  padding-left: 8px;
  text-align: left;
  line-height: 35px;
}
.file  .cell-name {
  padding-top: 6px;
  line-height: 22px;
}
.cell-input {
  height: 35px;
  width: 360px;
  margin: 0 auto;
  border: 0;
  font-size: 16px;
}
textarea {
  flex-grow: 1;
  margin: 0 auto;
  height: 100px;
  width: 362px;
  max-width: 362px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.submit {
  float: right;
  margin-top: 10px;
  margin-bottom: 15px;
}
.upload {
  position: relative;
  margin: 0 auto;
  width: 550px;
  height: 180px;
  text-align: center;
  /* border: 1px dashed #ccc; */
  border-radius: 4px;
  background: #f2f2f2;
}
.fileList {
  position: absolute;
  top: 14px;
  left: 12px;
  right: 12px;
  bottom: 4px;
  overflow-y: auto;
}
.el-upload-list__item-name {
  text-align: left;
}
.icon-folder {
  font-size: 15px;
  font-weight: 600;
  height: 100%;
  color: #97a8be;
  padding-left: 1px;
  margin-right: 6px;
}
.el-upload-list__item-name:hover .icon-folder {
  color: #97a8be;
}
.el-message__group {
  color: #212121 !important;
}
.cell .bottom_line {
  border-bottom: #d2d2d2 1px solid;
  border-left-width: 0px;
  border-right-width: 0px;
  border-top-width: 0px;
  outline: none;
  padding: 0 5px;
  width: 75%;
}
.rp_bottom {
  line-height:55px;
  padding: 0 30px;
  margin:15px 0;
}
.rp_bottom a {
  color:#007bc5;
}
.file-wrap {
  position: relative;
  height:300px;
}
.fileListTitle {
  padding: 0 35px;
  overflow: hidden;
  height: 34px;
  line-height: 34px;
}
.fileListTitle .name {
  width: 300px;
  float: left;
  text-align: left;
  padding: 0;
  height: 35px;
  line-height: 35px;
}
.fileListTitle .refesh {
  width: 120px;
  float: right;
}
.fileListTitle .refesh i {
  vertical-align: middle;
  color: rgba(117, 117, 117, 0.7);
}
.fileListTitle .refesh:hover i {
  cursor: pointer;
  color: #212121;
}
.refresh_animation {
  transform: rotate(1080deg);
  transition: all 3s;
}
.download-bottom {
  padding: 0 35px;
  height: 34px;
  text-align: left;
}
.download-bottom .persent-bottom,.download-bottom .bottom-progress {
  float: left;
  line-height: 34px;
}
.download-bottom .bottom-progress {
  width: 30%;
  padding: 12px 0;
}
.download-bottom .persent-bottom {
  width: 260px;
}
.transfer-style span {
  float: right;
  line-height: 32px;
}
</style>
